import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardImg,
  CardImgOverlay,
  Carousel,
  CarouselCaption,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
  Col,
  Container,
  Row,
} from "reactstrap";
import homeImage from "../../../../../assets/images/Travel/homeImage.jpg";
import TravelLinkService from "../../../../../services/TravelLinkService/TravelLinkService";
import { Link } from "react-router-dom";

const Home = () => {
  const [homeData, setHomeData] = useState({});
  const [bannerData, setBannerData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  // Fetch Home Data
  const fetchData = async () => {
    try {
      const response = await TravelLinkService.getHome();
      setHomeData(response);
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch Banner Data
  const fetchBannerData = async () => {
    try {
      const response = await TravelLinkService.getBanner();
      setBannerData(response);
    } catch (error) {
      console.log(error);
    }
  };

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      if (bannerData.length > 0) {
        setActiveIndex((current) =>
          current === bannerData.length - 1 ? 0 : current + 1
        );
      }
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [bannerData.length]);

  // Fetch data on component mount
  useEffect(() => {
    fetchData();
    fetchBannerData();
  }, []);

  const handlePrevious = () => {
    setActiveIndex((current) =>
      current === 0 ? bannerData.length - 1 : current - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((current) =>
      current === bannerData.length - 1 ? 0 : current + 1
    );
  };

  return (
    <>
      <div className="mb-4 mt-5 p-0">
        <div
          id="carouselExampleAutoplaying"
          data-bs-ride="carousel"
          className="carousel slide position-relative"
        >
          <div className="carousel-inner">
            {bannerData.length > 0 ? (
              bannerData.map((banner, index) => (
                <div
                  key={index}
                  className={`carousel-item ${
                    index === activeIndex ? "active" : ""
                  }`}
                  style={{ transition: "transform 0.6s ease-in-out" }}
                >
                  <div className="w-100 h-75 position-relative">
                    <Link
                      to={banner.url}
                      aria-label={`Go to ${banner.title}`}
                      onClick={(e) => {
                        console.log(
                          "Image clicked, navigating to:",
                          banner.url
                        );
                      }}
                    >
                      <img
                        src={banner.image_url}
                        className=" w-100 object-fit-cover"
                        alt={banner.title || `Slide ${index + 1}`}
                        style={{ maxHeight: "80vh" }}
                      />
                    </Link>
                    <div className="position-absolute bottom-0 start-0 w-100 bg-opacity-10 mb-0 mb-md-3 z-index-1">
                      <h3 className="container-fluid text-white fw-bold fs-2 fs-md-3 mb-0">
                        {banner.title}
                      </h3>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="carousel-item active">
                <p>Loading...</p>
              </div>
            )}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            onClick={handlePrevious}
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            onClick={handleNext}
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <Container fluid>
        <Row className="mb-5">
          <Col xs={12} md={6} lg={6} className="mb-2">
            <h1 className="fw-700">{homeData?.home?.page_title || ""}</h1>
            <p
              dangerouslySetInnerHTML={{
                __html: homeData?.home?.short_description,
              }}
              style={{ padding: "0px", margin: "0px" }}
            />
            <Link to="/destinations/nepal" className="btn btn-outline-info">
              Learn More
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} className="d-flex justify-content-end">
            <img
              src={homeData?.home?.page_image_url || ""}
              className="img-fluid rounded object-fit-cover"
              alt="Nepal & the Himalayas"
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;
